import React from 'react';
import { styled } from '@compiled/react';
import { lazy } from 'react-loosely-lazy';
import { graphql, useFragment } from 'react-relay';
import Button from '@atlaskit/button/standard-button';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import Placeholder from '@atlassian/jira-placeholder';
import type { async_softwareReleasesLaunchCard_AsyncVersionStatus$key } from '@atlassian/jira-relay/src/__generated__/async_softwareReleasesLaunchCard_AsyncVersionStatus.graphql';
import { GetCurrentStatusLabel, type VersionStatus } from './index';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyVersionStatus = lazy<typeof VersionStatus>(() =>
	import(/* webpackChunkName: "async-version-status" */ './index').then(
		(module) => module.VersionStatus,
	),
);

type Props = {
	jiraVersion: async_softwareReleasesLaunchCard_AsyncVersionStatus$key;
};

export const AsyncVersionStatus = ({ jiraVersion }: Props) => {
	const version = useFragment(
		graphql`
			fragment async_softwareReleasesLaunchCard_AsyncVersionStatus on JiraVersion {
				status @required(action: THROW)
				...versionStatus_softwareReleasesLaunchCard
			}
		`,
		jiraVersion,
	);

	return (
		<Placeholder
			name="version-status"
			fallback={
				<SkeletonContainer>
					<Button>{GetCurrentStatusLabel(version.status)}</Button>
				</SkeletonContainer>
			}
		>
			<LazyVersionStatus jiraVersion={version} />
		</Placeholder>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonContainer = styled.div({
	display: 'flex',
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 5}px`,
});
